import type { DealStage } from '@/types'

const FINANCE_QUEUE_ROLES = new Set(['FINANCEIRO', 'ADMIN', 'MANAGER'])

const FINANCE_DRIVEN_GERAR_CONTRATO_TARGETS = new Set<DealStage>([
  'contrato_enviado',
  'ajustar_proposta',
])

export const FINANCE_GERAR_CONTRATO_MESSAGE =
  'Em Gerar Contrato, o financeiro conduz o avanço da etapa. Acompanhe o chamado na aba Contrato.'

export function isFinanceQueueRole(role: string | undefined | null): boolean {
  return FINANCE_QUEUE_ROLES.has((role ?? '').toUpperCase())
}

export function isCloserBlockedGerarContratoExit(
  currentStage: DealStage,
  targetStage: DealStage,
  userRole?: string | null,
): boolean {
  if (currentStage !== 'gerar_contrato') return false
  if (isFinanceQueueRole(userRole)) return false
  return FINANCE_DRIVEN_GERAR_CONTRATO_TARGETS.has(targetStage)
}
